


//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/mock/empty.js
// module id = 80
// module chunks = 0